import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ru from 'vuetify/es5/locale/ru';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full';

import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/ru.json';

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule], // assign message
  });
});

// Register it globally
// main.js or any entry file.
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.use(Vuetify);

const opts = {
  lang: {
    locales: { ru },
    current: 'ru',
  },
  icons: {
    iconfont: 'mdi',
  },
};

const themes = {
  theme: {
    themes: {
      light: {
        primary: '#2979FF',
      },
    },
  },
};
const preset = { ...opts, ...themes };
export default new Vuetify(preset);
